import getMomentDateObj from "../getMomentDateObj"
import setMomentDateObjZero from "../setMomentDateObjZero"

const checkPerformanceByTimeRange = (startDate, endDate, performance) => {
    const performanceUTC = performance.timeUtc
    const utcSetToZero = setMomentDateObjZero(getMomentDateObj(performanceUTC))
    
    return getMomentDateObj(startDate).isSameOrBefore(utcSetToZero) && utcSetToZero.isSameOrBefore(getMomentDateObj(endDate))
}

export default checkPerformanceByTimeRange